import { BaseMonomer } from 'domain/entities/BaseMonomer';

export class Chem extends BaseMonomer {}
